import { ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, map, mergeMap } from 'rxjs/operators'

import { combineEpicsIsolated } from 'utils/epicRegistry'

import { selectActualCompanyId } from 'containers/App/selectors'

import { submitFirstLoginError, submitFirstLoginSuccess } from './actions'
import { SUBMIT_FIRST_LOGIN_ASYNC } from './constants'

const submitFirstLoginEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(SUBMIT_FIRST_LOGIN_ASYNC.INITIATE),
    mergeMap((action) =>
      api.login
        .submitFirstLogin({
          ...action.payload.data,
          company_id: selectActualCompanyId(state$.value),
        })
        .pipe(
          map(({ response }) => submitFirstLoginSuccess(response)),
          catchError((error) => of(epicsErrorHandler(submitFirstLoginError, error)))
        )
    )
  )

export default combineEpicsIsolated(submitFirstLoginEpic)
